import {FC} from "react";
import {
  IconGroup,
  ImageWrapper,
  SortByText,
  SortContainer,
  SortText,
} from "../styles";
import {Tooltip} from "react-tooltip";
import {IDataMapFiltered} from "../../../pages/Dashboard/Dashboard.type";

import {CustomSwitch} from "../../../ui/CustomSwitch";

interface IProps {
  handleSortTitle: any;
  handleSort: any;
  sortOption: string;
  dataMapFiltered: IDataMapFiltered[];
  setIsShowTitleParams?: (volume: boolean) => void;
  isShowTitleParams?: boolean;
  isHideSortBlock?: boolean;
}

export const BlockFIlteredMap: FC<IProps> = ({
  handleSortTitle,
  handleSort,
  sortOption,
  dataMapFiltered,
  setIsShowTitleParams,
  isShowTitleParams,
  isHideSortBlock,
}) => {
  return (
    <div>
      <SortText>{`${handleSortTitle()}`}</SortText>
      <SortContainer>
        <div
          style={{
            color: "#fff",
            display: "flex",
            alignItems: "center",
            fontSize: 12,
            gap: 10,
            textTransform: "uppercase",
          }}
        >
          <CustomSwitch
            checked={isShowTitleParams}
            onChange={(event) => setIsShowTitleParams?.(event.target.checked)}
          />
          Названия показателей
        </div>
        {!isHideSortBlock && (
          <IconGroup>
            <SortByText>СОРТИРОВАТЬ ПО:</SortByText>
            {dataMapFiltered.map((icon) => (
              <ImageWrapper
                key={icon.id}
                data-tooltip-id={`tooltip-sort`}
                data-tooltip-content={`${icon.title}`}
                data-tooltip-place="top"
                onClick={() => icon.option && handleSort(icon.option)}
                disabled={icon.disabled}
              >
                <img
                  src={sortOption === icon.option ? icon.img : icon.imgDefault}
                  alt={icon.title}
                  width="100%"
                  height="100%"
                  // style={
                  //   sortOption === icon.option ? {opacity: 1} : {opacity: 0.5}
                  // }
                />
                <Tooltip
                  id={`tooltip-sort`}
                  className="tooltip"
                  noArrow
                  offset={4}
                />
              </ImageWrapper>
            ))}
          </IconGroup>
        )}
      </SortContainer>
    </div>
  );
};
